import { defineComponent as _defineComponent } from 'vue'
import { QDataTableHeader, QButton, QSearchFiled } from '../../shared';
import { useSyncProp } from '../../../composables/useSyncProp';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  search: { type: String, required: true },
},
  emits: ['update:search', 'export-results-clicked'],
  setup(__props, { emit }) {

const props = __props




const searchComputed = useSyncProp('search', props, emit)

return { __sfc: true,props, emit, searchComputed, QDataTableHeader, QButton, QSearchFiled }
}

})